import { state } from '../lib/state.js';
import { loadLineCalculatorSettings, saveLineCalculatorSettings } from '../services/repository.js';
import { startCountryBrowserlessJob } from '../services/browserless-country-dispatch.js';
import { els } from '../app/dom.js';
import { requireAuthenticatedSession } from '../app/auth.js';
import { setStatus, sectionDistanceKm, formatDuration } from '../lib/app-helpers.js';
import { prepareSectionMetrics } from './common.js';

const HUGO_SETTINGS_KEY = 'd24-hugo-hu-settings';
let pendingHugoSection = null;

export async function openHugoDialog(section){
  pendingHugoSection=section;
  const localDefaults=loadHugoSettings();
  let savedForLine=null;
  try{savedForLine=await loadLineCalculatorSettings(state.organizationId,state.currentRoute.lineNumber,'hugo-hu');}catch(error){console.warn('[D24 HU-GO] Parametry linii:',error);}
  const defaults={...localDefaults,...(savedForLine||{})};
  els.hugoVehicleType.value=defaults.vehicleType||'M3';
  els.hugoCategory.value=defaults.category||'J2';
  els.hugoEmissionClass.value=defaults.emissionClass||'EURO6';
  els.hugoAxleWeight.value=defaults.axleWeight||'11.5';
  els.hugoGrossWeight.value=defaults.grossWeight||'19';
  els.hugoHeight.value=defaults.height||'3.8';
  els.hugoWidth.value=defaults.width||'2.55';
  els.hugoLength.value=defaults.length||'13.5';
  els.hugoDialogRoute.textContent=`${section.countryName}: ${section.points.map(point=>point.name).join(' → ')}`;
  els.hugoDialog.classList.remove('hidden');
  els.hugoDialog.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  setTimeout(()=>els.hugoVehicleType.focus(),0);
}

export function closeHugoDialog(){
  pendingHugoSection=null;
  els.hugoDialog?.classList.add('hidden');
  els.hugoDialog?.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
}

export async function submitHugoDialog(event){
  event.preventDefault();
  if(!pendingHugoSection)return;
  if(!els.hugoForm.reportValidity())return;
  const section=pendingHugoSection;
  const settings={
    vehicleType:els.hugoVehicleType.value,
    category:els.hugoCategory.value,
    emissionClass:els.hugoEmissionClass.value,
    axleWeight:els.hugoAxleWeight.value,
    grossWeight:els.hugoGrossWeight.value,
    height:els.hugoHeight.value,
    width:els.hugoWidth.value,
    length:els.hugoLength.value,
  };
  localStorage.setItem(HUGO_SETTINGS_KEY,JSON.stringify(settings));
  try{await saveLineCalculatorSettings(state.organizationId,state.currentRoute.lineNumber,'hugo-hu',settings);}catch(error){return setStatus(els.extensionStatus,`Nie udało się zapisać parametrów HU-GO: ${error.message}`,'error');}
  closeHugoDialog();
  await runHugoHu(section,settings);
}

export async function runHugoHu(section,settings={}){
  if(!await requireAuthenticatedSession('uruchomić kalkulator HU-GO Węgry'))return;

  const preparedSection=await prepareSectionMetrics(section,'węgierskiego');
  if(!preparedSection)return;
  if((preparedSection.points||[]).length>10){
    const message=`HU-GO: obecna automatyzacja obsługuje maksymalnie 10 punktów trasy. Odcinek ma ${preparedSection.points.length}. Zmniejsz liczbę punktów przed uruchomieniem Browserless.`;
    window.alert(message);
    return setStatus(els.extensionStatus,message,'warning');
  }

  const distanceKm=sectionDistanceKm(preparedSection);
  const durationText=Number.isFinite(Number(preparedSection.durationSeconds))
    ?formatDuration(Number(preparedSection.durationSeconds))
    :'';
  const jobId=crypto.randomUUID();
  const payload={
    jobId,
    calculatorKey:'hugo-hu',
    routeId:state.currentRoute.id,
    routeVersionId:state.currentRoute.versionId,
    routeTitle:state.currentRoute.title,
    sourceFile:state.currentRoute.sourceFileName,
    countryCode:'HU',
    countryName:'Węgry',
    sectionId:preparedSection.id,
    sectionOrder:preparedSection.order,
    distanceKm,
    durationText,
    points:preparedSection.points.map(p=>({
      name:p.name,
      address:p.address||'',
      countryCode:p.countryCode||'',
      countryName:p.countryName||'',
      country:p.countryName||'',
      type:p.isBorder?'Granica':'Przystanek',
      pointType:p.isBorder?'border':'stop',
      lat:p.lat,
      lon:p.lon,
      isBorder:Boolean(p.isBorder),
      borderName:p.borderName||'',
      requestedBorderPair:p.requestedBorderPair||'',
      resolvedDisplayName:p.resolvedDisplayName||'',
      query:`${p.lat}, ${p.lon}`,
    })),
    settings:{...settings},
  };

  setStatus(els.extensionStatus,`Uruchamiam HU-GO w Browserless (${preparedSection.points.length} punktów)…`,'working');
  try{await startCountryBrowserlessJob(payload);}catch(error){console.error('[D24 BROWSERLESS HU-GO]',error);}
}


export function loadHugoSettings(){
  try{return JSON.parse(localStorage.getItem(HUGO_SETTINGS_KEY)||'{}');}
  catch{return {};}
}

